<div *ngIf="course">
    <div>{{course.id}}</div>
</div>